import { useDispatch } from 'react-redux';
import { showToast, hideToast } from '../freeTrialToast';

export const useFreeTrialToast = () => {
  const dispatch = useDispatch();

  const showFreeTrialToast = (options?: {
    message?: string;
    route?: string;
    routeLabel?: string;
    autoClose?: boolean;
  }) => {
    dispatch(showToast(options || {}));
  };

  const hideFreeTrialToast = () => {
    dispatch(hideToast());
  };

  return {
    showFreeTrialToast,
    hideFreeTrialToast,
  };
}; 